import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import AdminView from "./view";

class Admin extends Component {
  componentDidMount() {
    // const { history, user } = this.props;
    // if(!user.token || user.type !== 'admin') history.push('/');
  }

  render() {
    return <AdminView />;
  }
}

const mapStateToProps = ({ post, user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Admin));
